import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../services/http/wordpress/wordpress.interface';
import { LoaderService } from '../../services/loader/loader.service';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  title = $localize`:@@Faq.title:Preguntas frecuentes`;
  description = "";
  image = "assets/images/FAQS.jpg";

  blocks: {
    title: string,
    questions: {
      id: number,
      question: string,
      answer: string,
      order: number
    }[]
  }[] = [];

  constructor(
    private readonly wordpressService: WordpressService,
    private readonly loaderService: LoaderService
  ) {
    this.loaderService.show();
    this.wordpressService.getPosts({ client: WpClientCode.genCat, section: WpSectionCode.faq }).subscribe((data) => {
      if (data) {
        // group by blocks, if not have block set ''
        const blocks = data.reduce((acc, post) => {
          const block = post.acf?.bloque || '';
          if (!acc[block]) {
            acc[block] = [];
          }
          acc[block].push({
            id: post.id,
            question: post.title.rendered,
            answer: post.content.rendered,
            order: post.acf?.orden_faq || 0
          });
          return acc;
        }, {} as { [key: string]: { id: number, question: string, answer: string, order: number }[] });
        console.log(blocks);
        this.blocks = Object.keys(blocks).map((key) => {
          return {
            title: key,
            questions: blocks[key].sort((a, b) => a.order - b.order)
          };
        });
      }
      this.loaderService.hide();
    });
  }

  scrollTo(questionId: number) {
    const element = document.getElementById(`question-${questionId}`);
    if (element) {
      const headerOffset = 400; // Altura del header fijo
      const elementPosition = element.getBoundingClientRect().top; // Posición del elemento relativa al viewport
      const offsetPosition = elementPosition + window.scrollY - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
}
